import { observable, action, computed } from "mobx";
import Address from "./Address";

export default class Guest {
  /**
   * @property {number|null}
   */
  @observable guestId = null;

  /**
   * @property {string}
   */
  @observable firstName = "";

  /**
   * @property {string}
   */
  @observable lastName = "";

  /**
   * @property {string}
   */
  @observable email = "";

  /**
   * @property {string}
   */
  @observable contactPhone = "";

  /**
   * @property {string}
   */
  @observable address = {};

  constructor(data) {
    if (typeof data !== "undefined") {
      this.setData(data);
    }
  }

  @action setData(data) {
    const { guestId, firstName, lastName, email, contactPhone, address } = data;

    this.guestId = guestId || 0;
    this.firstName = firstName || "";
    this.lastName = lastName || "";
    this.email = email || "";
    this.contactPhone = contactPhone || "";

    this.address = new Address(address);
  }

  @computed
  get currency() {
    if (typeof this.address.country !== "undefined" && this.address.country === "Canada") {
      return "cad";
    }

    return "usd";
  }
}
